module.exports = __webpack_public_path__ + "static/frost_giant_dwarf-6004d56ea6016188964676a4d7b4c16a.jpg";